import ExcelJS from 'exceljs';

export async function exportResultsToXlsx(
  columns: string[],
  data: Record<string, unknown>[],
  formatHeader: (col: string, data: Record<string, unknown>[]) => string,
  formatCell: (value: unknown) => string,
  filename?: string,
): Promise<void> {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Results');

  const headers = columns.map((col) => formatHeader(col, data));
  ws.addRow(headers);

  for (const row of data) {
    ws.addRow(columns.map((col) => formatCell(row[col])));
  }

  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || 'cypher-results.xlsx';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
